export default function ArchiveImages() {
    return (
        <div className='flex flex-col justify-center items-center gap-5 md:gap-9 mt-[48px] md:mt-[98px] drop-shadow-md rounded-[15px] pt-5 md:pt-0'>
            <img src='https://ik.imagekit.io/bpfumapog/archive1.png?tr=f-auto,q-80' alt='archive1' className='max-w-[390px] md:max-w-[996px]'/>
            <img src='https://ik.imagekit.io/bpfumapog/archive2.png?tr=f-auto,q-80' alt='archive2' className='max-w-[390px] md:max-w-[996px]'/>
            <img src='https://ik.imagekit.io/bpfumapog/archive3.png?tr=f-auto,q-80' alt='archive3' className='max-w-[390px] md:max-w-[996px] rounded-[4px]'/>
            <img src='https://ik.imagekit.io/bpfumapog/archive4.png?tr=f-auto,q-80' alt='archive4' className='max-w-[390px] md:max-w-[996px]'/>
            <img src='https://ik.imagekit.io/bpfumapog/archive5.png?tr=f-auto,q-80' alt='archive5' className='max-w-[390px] md:max-w-[996px]'/>
            <img src='https://ik.imagekit.io/bpfumapog/archive6.png?tr=f-auto,q-80' alt='archive6' className='max-w-[390px] md:max-w-[996px]'/>
        </div>
    )

}
